import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Box } from '@mui/material';
import AppLayout from '../../layouts/app/AppLayout';
import AppIcons from '../../assets/images/icons';
import SVGIcons from '../../assets/images/icons/svgIcons';
import './custom.scss';


// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function ComingSoon() {
  const pageName = 'Coming Soon';
  return (
    <AppLayout
      // isLoadHeader={false}
      // isLoadFooter={false}
      pageName={pageName}
    >
      <div className='coming-soon-wrp f-wrp'>
        <div className='main-container-wrp'>
          <div className='coming-soon-con f-wrp'>
            <span className='image-wrp'>
              <Box
                component="img"
                src={AppIcons.BlueLogo}
                sx={{ height: 'auto', maxWidth: '325px', mx: 'auto', my: { xs: 1, sm: 1 } }}
              />
            </span>
            <h1>Coming Soon</h1>
            <p>We are currently working on creating something fantastic.</p>
            <p>We'll update it Soon..</p>
            <div className='btn-wrp'>
              <Button className='sqr-btn' to="/" size="large" variant="contained" component={RouterLink}>
                Back to Home <SVGIcons.LearnMoreArrow />
              </Button>
            </div>

          </div>
        </div>
      </div>
      {/* <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Box
            component="img"
            src={AppIcons.BlueLogo}
            sx={{ height: 'auto', maxWidth: '325px', mx: 'auto', my: { xs: 1, sm: 1 } }}
          />
          <Typography variant="h3" paragraph>
sdsds
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>
            we are
          </Typography>


          <Button to="/" size="large" variant="contained" component={RouterLink}>
            Go to Home
          </Button>
        </StyledContent>
      </Container> */}
    </AppLayout>
  );
}
